import { TableCellHeight } from '../types/types';

export const tableCellHeightClassNameLookup: Record<TableCellHeight, string> = {
  compact: 'py-1',
  cozy: 'py-2',
  standard: 'py-4',
  comfortable: 'py-6',
};
